export const TransformTypes = {
  RESIZE: "resize",
  MOVE: "move",
  ROTATE: "rotate",
};


/**
 * @type {{
 *  TOP_LEFT: "tl",
 *  TOP_RIGHT: "tr",
 *  TOP_MIDDLE: "tm",
 *  LEFT_MIDDLE: "lm",
 *  RIGHT_MIDDLE: "rm",
 *  BOTTOM_LEFT: "bl",
 *  BOTTOM_RIGHT: "br",
 *  BOTTOM_MIDDLE: "bm",
 * }}
 */
export const Positions = {
  TOP_LEFT: "tl",
  TOP_RIGHT: "tr",
  TOP_MIDDLE: "tm",
  LEFT_MIDDLE: "lm",
  RIGHT_MIDDLE: "rm",
  BOTTOM_LEFT: "bl",
  BOTTOM_RIGHT: "br",
  BOTTOM_MIDDLE: "bm",
};

export const Mode = {
  SINGLE: 1,
  MULTI: 2,
};

export const CenterHandles = {
  [Positions.TOP_MIDDLE]: true,
  [Positions.BOTTOM_MIDDLE]: true,
  [Positions.LEFT_MIDDLE]: true,
  [Positions.RIGHT_MIDDLE]: true,
};

export const SCALE_MIN = 0.001;

export const TRANSFORMABLE_AREA_CLASSNAME = "transformable-area";
